import { cloneDeep } from "lodash";
import {
  arrangeLayersZIndex,
  removeLayerById,
} from "../components/map/mapUtils";

const initialState = {};

export default function layerReducer(state = initialState, action) {
  switch (action.type) {
    case "layer/add":
      {
        let newState = { ...state };

        if (!newState[action.payload.id]) {
          newState[action.payload.id] = action.payload;
        }

        return newState;
      }
      break;

    case "layer/unshift":
      {
        let newState = { ...state };

        if (!newState[action.payload.id]) {
          newState[action.payload.id] = action.payload;
        }

        return newState;
      }
      break;

    case "layer/removeall":
      {
        let newState = {};

        return newState;
      }
      break;

    case "loadconfiguration":
      {
        let newState = {};

        return newState;
      }
      break;
    // case "layer/registeredlayertree/add": {
    //   let newState = { ...state };

    //   if (!newState[action.payload.id]) {
    //     newState[action.payload.id] = action.payload;
    //   }

    //   return newState;
    // }

    case "cqlFilter/layer/add":
      {
        let newState = cloneDeep(state);

        if (!newState[action.payload.id]["cqlFilter"]) {
          newState[action.payload.id]["cqlFilter"] = "";
        }
        newState[action.payload.id]["cqlFilter"] = action.payload.cqlFilter;

        return newState;
      }
      break;

    case "cqlFilter/layer/delete":
      {
        let newState = cloneDeep(state);

        if (newState[action.payload.id]) {
          newState[action.payload.id]["cqlFilter"] = "";
        }

        return newState;
      }
      break;

    case "layer/update": {
      let newState = cloneDeep(state);

      if (!newState[action.payload.id][action.payload.property]) {
        newState[action.payload.id][action.payload.property] = "";
      }

      newState[action.payload.id][action.payload.property] =
        action.payload.value;

      return newState;
    }

    case "sldEditor/editors/add":
      {
        let newState = cloneDeep(state);

        if (!newState[action.payload.id]["slds"]) {
          newState[action.payload.id]["slds"] = [];
        }

        console.log(newState[action.payload.id]["slds"]);
        let sldIdIndex = -1;

        state[action.payload.id]["slds"]?.forEach((el, idx) => {
          if (action.payload.sldId === el.sldId) {
            sldIdIndex = idx;
          }
        });

        if (sldIdIndex >= 0) {
          newState[action.payload.id]["slds"][sldIdIndex] = {
            title: action.payload.title,
            sldId: action.payload.sldId,
          };
        } else {
          newState[action.payload.id]["slds"] = [
            ...newState[action.payload.id]["slds"],
            { title: action.payload.title, sldId: action.payload.sldId },
          ];
        }

        return newState;
      }
      break;

    case "layer/loaded": {
      let newState = cloneDeep(state);

      if (!newState[action.payload.id]["mapLayer"]) {
        newState[action.payload.id]["mapLayer"] = "";
      }
      newState[action.payload.id]["mapLayer"] = action.payload.mapLayer;
      newState[action.payload.id]["loaded"] = true;

      return newState;
    }

    case "layer/deleteById": {
      let newState = cloneDeep(state);

      delete newState[action.payload];

      removeLayerById(action.payload);

      return newState;
    }
    case "layer/state/update": {
      let newState = { ...action.payload };

      return newState;
    }

    case "layer/state/append": {
      let newState = { ...state };

      Object.keys(action.payload).forEach((e) => {
        newState[e] = action.payload[e];
      });

      return newState;
    }

    default:
      return state;
  }
}
